import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=3a991620&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=3a991620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a991620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a991620')) {
      api.createRecord('3a991620', component.options)
    } else {
      api.reload('3a991620', component.options)
    }
    module.hot.accept("./ProductDetail.vue?vue&type=template&id=3a991620&scoped=true&", function () {
      api.rerender('3a991620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductDetail.vue"
export default component.exports